export default __webpack_public_path__ + "static/media/action-increase.b97f0d42.png";